module.exports = __webpack_public_path__ + "static/media/29FUNOV13.6a3731a8.jpg";